
import { pageHeroImages } from '../../../utils/images';

export default function HeroSection() {
  return (
    <section className="relative h-[400px] bg-gray-900 text-white overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('${pageHeroImages.services}')`
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center" style={{ paddingTop: '40px' }}>
        <div className="w-full text-center">
          <h1 className="text-4xl lg:text-5xl font-light mb-4 leading-tight">
            Our Manufacturing Services
          </h1>
          <p className="text-lg text-gray-200 max-w-2xl mx-auto font-light leading-relaxed">
            End-to-end apparel manufacturing solutions with expertise in leather processing,
            outerwear production, and global trade compliance
          </p>
        </div>
      </div>
    </section>
  );
}
